import { Component, inject } from '@angular/core';
import { SessionService } from '../../../../../../services/session-service';
import { ChoosePasswordRequest } from '../../../../../../models/users/requests/choose-password-request';
import { EmployerAuthViewModel } from '../../../../viewModels/employer-auth-view-model';
import { BaseComponent } from '../../../../../../models/base/base-component';
import { PasswordInputUtils } from '../../../../../../utils/password-input-utils';
import { createChoosePasswordFormGroup } from '../../../../forms/choose-password-form-group';

@Component({
  selector: 'app-employer-choose-password',
  templateUrl: './employer-choose-password.component.html',
  styleUrls: ['./employer-choose-password.component.scss', '../../auth.component.scss']
})
export class EmployerChoosePasswordComponent extends BaseComponent {
  viewModel = inject(EmployerAuthViewModel);

  public readonly passwordHintText = PasswordInputUtils.passwordHintText;

  public formGroup = createChoosePasswordFormGroup({ emailDisabled: true });
  public formSubmitted = false;

  public customErrorMessages = {
    password: {
      passwordMinLength: $localize`Password must be at least 8 characters`,
      passwordMaxLength: $localize`Password cannot exceed 50 characters`
    },
    eula: {
      required: $localize`Terms and Conditions must be accepted in order to continue.`
    }
  };

  private challengeName = '';
  private sessionId = '';

  constructor(private session: SessionService) {
    super();
  }

  setupBindings(): void {}

  // Prefill runs in setupViews (ngOnInit) so synchronous emissions patch the form before the first change detection pass
  setupViews() {
    this.session.sessionContainer$.once(session => {
      if (!session) session = this.viewModel.getCachedSession();
      const user = session?.user;
      this.formGroup.controls.email.patchValue(user?.email ?? '');
      this.sessionId = user?.sessionId ?? '';
      this.challengeName = user?.challengeName ?? '';
    });
  }

  public submit(): void {
    this.formSubmitted = true;
    if (this.formGroup.invalid) {
      return;
    }
    const { email, password, confirmPassword, eulaAccepted } = this.formGroup.getRawValue();
    const req = new ChoosePasswordRequest(
      email,
      password,
      confirmPassword,
      this.challengeName,
      this.sessionId,
      eulaAccepted
    );
    this.viewModel.setNewEmployerPassword(req);
  }
}
